<template>
  <div class="salesman-form-base" v-loading="loading">
    <Form ref="form" :model="formData" :label-width="90" class="page-form">
      <FormItem prop="staffNo" class="flex" label="工号" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.staffNo" placeholder="请输入" />
        <Button class="save-btn" type="primary" @click="createStaffNo">自动生成</Button>
      </FormItem>
      <FormItem prop="name" label="姓名" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.name" placeholder="请输入" />
      </FormItem>
      <FormItem
        prop="mobile"
        label="手机号"
        :rules="oldMobile || registerId || mobileEye ? { required: true, message: '请输入正确的手机号' } : $units.formRule.tel('请输入正确的手机号', true)"
      >
        <div class="tips">
          <Input
            v-if="formData.eyeShow || !formData.id || !mobileEye"
            v-model="formData.mobile"
            placeholder="请输入"
            @on-change="mobileChange"
            :disabled="!!registerId"
          />
          <Input v-else v-model="formData.mobile1" placeholder="请输入" @on-change="mobileChange" :disabled="!!registerId" />
          <span v-if="mobileEye && formData.mobile1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow && formData.id" @click="openEye('mobile', 'eyeShow')"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow && formData.id" @click="openEye('mobile', 'eyeShow')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem label="所属机构" prop="organizationId" v-if="registerId || !formData.id" :rules="$units.formRule.required('请选择')">
        <select-tree
          type="4"
          v-model="formData.organizationId"
          :isAll="true"
          ref="selectTree"
          @change="getGroupList"
          :status="registerId ? '1' : '-1'"
        ></select-tree>
      </FormItem>
      <FormItem label="所属机构" v-else>
        <Input :value="formData.organizationName" disabled />
      </FormItem>
      <FormItem label="所属团队" v-if="registerId || !formData.id" prop="groupId" key="groupId" :rules="$units.formRule.required('请选择')">
        <Select v-model="formData.groupId" clearable @on-change="changeGroup">
          <Option v-for="(bean, i) in groupList" :key="i" :value="bean.groupId">
            {{ bean.groupCode ? bean.groupName + '-' + bean.groupCode : bean.groupName }}
          </Option>
        </Select>
      </FormItem>
      <FormItem label="所属团队" v-else>
        <Input :value="formData.groupName" disabled />
      </FormItem>
      <FormItem prop="entryTime" label="入职日期" :rules="$units.formRule.objRequired('请选择')">
        <DatePicker type="date" v-model="formData.entryTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
      </FormItem>
      <FormItem prop="workingState" label="状态">
        <RadioGroup v-model="formData.workingState">
          <Radio label="1" :disabled="formData.id && !registerId ? true : false">在职</Radio>
          <Radio label="0" :disabled="formData.id && !registerId ? true : false">离职</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="离职时间" v-if="formData.workingState == 0" prop="resignTime" :rules="$units.formRule.objRequired('请选择')">
        <DatePicker type="date" v-model="formData.resignTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
      </FormItem>
      <FormItem prop="isSus" label="是否停职">
        <RadioGroup v-model="formData.isSus">
          <Radio label="1" :disabled="formData.id && !registerId ? true : false">是</Radio>
          <Radio label="0" :disabled="formData.id && !registerId ? true : false">否</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem
        prop="certificateNumber"
        label="执业证号"
        :rules="$units.formRule.required('请输入')"
        v-if="formData.workingState == '1' && (formData.isSus == '1' || formData.isSus == '0')"
        key="certificateNumber1"
      >
        <div class="tips">
          <Input v-model="formData.certificateNumber" placeholder="请输入" :disabled="formData.id && !registerId" />
          <Poptip trigger="hover" v-if="formData.id && !registerId">
            <Icon type="ios-help-circle-outline" size="18" style="margin-left: 6px; margin-top: 2px" />
            <div slot="content" style="color: #333">执业证号不可直接变更，请操作上号或注销执业证</div>
          </Poptip>
        </div>
      </FormItem>
      <FormItem prop="certificateNumber" label="执业证号" v-else key="certificateNumber2">
        <div class="tips">
          <Input v-model="formData.certificateNumber" placeholder="请输入" :disabled="formData.id && !registerId" />
          <Poptip trigger="hover" v-if="formData.id && !registerId">
            <Icon type="ios-help-circle-outline" size="18" style="margin-left: 6px; margin-top: 2px" />
            <div slot="content" style="color: #333">执业证号不可直接变更，请操作上号或注销执业证</div>
          </Poptip>
        </div>
      </FormItem>
      <FormItem :label-width="120" prop="certificateIssuanceDate" label="执业证生效日期">
        <DatePicker type="date" v-model="formData.certificateIssuanceDate" format="yyyy-MM-dd" placeholder="请选择" key="certificateIssuanceDate"></DatePicker>
      </FormItem>
      <FormItem :label-width="120" prop="certificateEndDate" label="执业证失效日期">
        <DatePicker type="date" v-model="formData.certificateEndDate" format="yyyy-MM-dd" placeholder="请选择" key="certificateEndDate"></DatePicker>
      </FormItem>

      <FormItem label="推荐人">
        <lzSelect placeholder="请输入姓名或工号搜索" v-model="formData.userId" :remote-method="getIntroUserList" ref="recommendSelect">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name" v-if="formData.id != item.id">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </template>
        </lzSelect>
      </FormItem>
      <FormItem label="辅导人">
        <lzSelect placeholder="请输入姓名或工号搜索" v-model="formData.mentor" :remote-method="getOrgUserList">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name" v-if="formData.id != item.id">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </template>
        </lzSelect>
      </FormItem>
      <FormItem v-if="$units.isOkBao() || $units.isOkTX()" label="上级主管">
        <lzSelect placeholder="请输入姓名或工号搜索" v-model="formData.groupLeaderId" :remote-method="getOkBaoOrgUserList">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </template>
        </lzSelect>
      </FormItem>
      <FormItem v-else label="上级主管">
        <lzSelect placeholder="请输入姓名或工号搜索" v-model="formData.groupLeaderId" :remote-method="getOrgUserList" :disabled="true">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name" v-if="formData.id != item.id">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </template>
        </lzSelect>
      </FormItem>
      <FormItem label="育成人">
        <lzSelect placeholder="请输入姓名或工号搜索" v-model="formData.breedId" :remote-method="getOrgUserList">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name" v-if="formData.id != item.id">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </template>
        </lzSelect>
      </FormItem>
      <FormItem label="负责人">
        <lzSelect placeholder="请输入姓名或工号搜索" v-model="formData.chargeId" :remote-method="getOrgUserList">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name" v-if="formData.id != item.id">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </template>
        </lzSelect>
      </FormItem>

      <template v-if="$units.isOkBao() || $units.isRYBB()">
        <FormItem label="个险销售支持">
          <Select
            v-model="formData.saleSupportId"
            clearable
            filterable
            :disabled="(!!formData.id && formData.isSaleSupport == '1') || (!formData.id && formData.isSaleSupport == '1')"
          >
            <Option v-for="(item, i) in salesSupportList" :key="i" :value="item.id" :label="item.name"></Option>
          </Select>
        </FormItem>
        <FormItem label="团险销售支持">
          <Select
            v-model="formData.groupSaleSupportId"
            clearable
            filterable
            :disabled="(!!formData.id && formData.isSaleSupport == '1') || (!formData.id && formData.isSaleSupport == '1')"
          >
            <Option v-for="(item, i) in groupSalesSupportList" :key="i" :value="item.id" :label="item.name"></Option>
          </Select>
        </FormItem>
        <FormItem label="是否为销支">
          <RadioGroup v-model="formData.isSaleSupport" @on-change="onChangeIsSaleSupport">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="formData.isSaleSupport == 1" label="销支类型" prop="saleSupportType" :rules="$units.formRule.required('请选择', 'change', 'number')">
          <RadioGroup v-model="formData.saleSupportType" @on-change="onChangeSaleSupportType">
            <Radio :label="1">个险</Radio>
            <Radio :label="2">团险</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="$units.isOkBao() || $units.isOkTX()" label="来源渠道">
          <Select v-model="formData.sourceChannel" clearable filterable :disabled="!$units.pointAction('org_2_19')">
            <Option v-for="(item, i) in channelList" :key="i" :value="item" :label="item"></Option>
          </Select>
        </FormItem>
        <FormItem
          prop="weixinQrCode"
          label="二维码"
          :rules="$units.formRule.required('请上传二维码', 'change')"
          v-if="formData.isSaleSupport == '1'"
          key="formData.weixinQrCode"
        >
          <upload :muti="false" :arr="formData.weixinQrCode" @remove="removeCover()" @upload="toloadFile" />
        </FormItem>
      </template>

      <FormItem prop="sex" label="性别">
        <RadioGroup v-model="formData.sex">
          <Radio label="1">男</Radio>
          <Radio label="2">女</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="证件类型" prop="idType" :rules="$units.formRule.required('请选择')">
        <Select v-model="formData.idType" clearable @on-change="$set(formData, 'idNo', '')">
          <Option v-for="(item, index) in idTypeList" :value="item.value" :key="index">{{ item.txt }}</Option>
        </Select>
      </FormItem>
      <FormItem
        prop="idNo"
        label="证件号"
        :rules="oldIdNo || idEye ? { required: true, message: '请输入正确的身份证号' } : $units.formRule.idCard()"
        v-if="formData.idType == '01'"
        key="idNo1"
      >
        <div class="tips">
          <Input v-if="formData.eyeShow1 || !formData.id || !idEye" v-model="formData.idNo" placeholder="请输入" @on-change="idCardChange" />
          <Input v-else v-model="formData.idNo1" placeholder="请输入" @on-change="idCardChange" />
          <span v-if="idEye && formData.idNo1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow1" @click="openEye('idNo', 'eyeShow1')"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow1 && formData.id" @click="openEye('idNo', 'eyeShow1')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem prop="idNo" label="证件号" :rules="strLength()" v-else key="-">
        <div class="tips">
          <Input v-if="formData.eyeShow1 || !formData.id || !idEye" v-model="formData.idNo" placeholder="请输入" @on-change="idCardChange($event, 1)" />
          <Input v-else v-model="formData.idNo1" placeholder="请输入" @on-change="idCardChange($event, 1)" />
          <span v-if="idEye && formData.idNo1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow1" @click="openEye('idNo', 'eyeShow1')"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!formData.eyeShow1 && formData.id" @click="openEye('idNo', 'eyeShow1')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem prop="date" label="证件有效期">
        <DatePicker
          type="date"
          v-model="formData.date2"
          format="yyyy-MM-dd"
          placeholder="请选择"
          key="date"
          style="width: calc(100% - 65px); margin-right: 7px"
          v-if="formData.isLongEffective == 1"
        ></DatePicker>
        <DatePicker
          type="daterange"
          v-model="formData.date"
          format="yyyy-MM-dd"
          placeholder="请选择"
          key="daterange"
          style="width: calc(100% - 65px); margin-right: 7px"
          v-else
        ></DatePicker>
        <i-switch v-model="formData.isLongEffective" size="large" true-value="1" false-value="0" @on-change="isLongEffectiveChange">
          <span slot="open">长期</span>
          <span slot="close">短期</span>
        </i-switch>
      </FormItem>
      <FormItem label="出生日期">
        <DatePicker type="date" :value="formData.birthday" format="yyyy-MM-dd" placeholder="请选择" @on-change="changeBirthday"> </DatePicker>
      </FormItem>
      <FormItem prop="outlook" label="政治面貌">
        <lzDicSelect v-model="formData.outlook" dicType="OUTLOOK"></lzDicSelect>
      </FormItem>
      <FormItem prop="nation" label="民族">
        <Select v-model="formData.nation" filterable>
          <Option v-for="text in nationList" :value="text" :key="text">{{ text }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="maritalStatus" label="婚姻状态">
        <lzDicSelect v-model="formData.maritalStatus" dicType="MARITAL"></lzDicSelect>
      </FormItem>
      <FormItem prop="education" label="学历">
        <lzDicSelect v-model="formData.education" dicType="EDUCATION"></lzDicSelect>
      </FormItem>
      <FormItem prop="isGroupLeader" label="团队长" :rules="$units.formRule.required('请选择')">
        <RadioGroup v-model="formData.isGroupLeader">
          <Radio label="1" :disabled="$units.isOkBao() || $units.isOkTX()">是</Radio>
          <Radio label="0" :disabled="$units.isOkBao() || $units.isOkTX()">否</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="email" label="邮箱" :rules="oldEmail || emailEye ? { required: false, message: '请输入正确的邮箱地址' } : $units.formRule.email(false)">
        <div class="tips">
          <Input v-if="formData.eyeShow2 || !emailEye" v-model="formData.email" placeholder="请输入" @on-change="emailChange" />
          <Input v-else v-model="formData.email1" placeholder="请输入" @on-change="emailChange" />
          <span v-if="emailEye && formData.email1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow2" @click="openEye('email', 'eyeShow2')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye('email', 'eyeShow2')"></i>
          </span>
        </div>
      </FormItem>
      <!-- <FormItem prop="email" label="邮箱" :rules="$units.formRule.email(false)">
        <Input v-model="formData.email" placeholder="请输入" />
      </FormItem> -->

      <FormItem prop="rankId" label="职级" class="two">
        <Select v-if="!formData.id && userInfo.orgType == 1" v-model="formData.rankId" filterable :disabled="!!formData.id" style="width: calc(50% - 70px)">
          <Option v-for="item in rankList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <div class="tips" v-else>
          <Select v-model="formData.rankId" filterable :disabled="!!formData.id" style="width: calc(50% - 70px)">
            <Option v-for="item in rankList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
          <Poptip trigger="hover" v-if="formData.id">
            <Icon type="ios-help-circle-outline" size="18" style="margin-left: 6px; margin-top: 2px" />
            <div slot="content" style="color: #333">职级不可直接变更，请通过晋升降级操作</div>
          </Poptip>
        </div>
        <span class="text-btn" @click="$refs.editPromotion.open({})" v-if="!formData.id && userInfo.orgType == 1">新增职级</span>
      </FormItem>
      <br />
      <FormItem prop="companyName" label="公司名称">
        <Input v-model="formData.companyName" placeholder="请输入" />
      </FormItem>
      <FormItem prop="companyAddress" label="公司地址" class="two">
        <Input v-model="formData.companyAddress" placeholder="请输入" type="textarea" :autosize="{ minRows: 1 }" />
      </FormItem>
      <FormItem
        prop="cardNo"
        label="银行卡号"
        :rules="
          oldCardNo || cardNoEye
            ? { required: false, message: '请输入正确的银行卡号' }
            : { required: false, validator: validateMessage, message: '请输入正确的银行卡号', trigger: 'change' }
        "
      >
        <div class="tips">
          <Input v-if="formData.eyeShow3 || !cardNoEye" v-model="formData.cardNo" placeholder="请输入" @on-change="cardNoChange" />
          <Input v-else v-model="formData.cardNo1" placeholder="请输入" @on-change="cardNoChange" />
          <span v-if="cardNoEye && formData.cardNo1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow3" @click="openEye('cardNo', 'eyeShow3')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye('cardNo', 'eyeShow3')"></i>
          </span>
        </div>
      </FormItem>
      <!-- <FormItem prop="cardNo" label="银行卡号">
        <Input v-model="formData.cardNo" placeholder="请输入" @on-change="cardNoChange" />
      </FormItem> -->
      <FormItem prop="bank" label="开户银行">
        <Select v-model="formData.bank" filterable clearable>
          <Option v-for="(txt, value) in bankList" :value="value" :key="value">{{ txt }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="accountOpenBranch" label="银行支行">
        <Input v-model="formData.accountOpenBranch" placeholder="请输入" />
      </FormItem>
      <FormItem label="社保号">
        <Input v-model="formData.socialNo" placeholder="请输入" />
      </FormItem>
      <FormItem label="公积金账号">
        <Input v-model="formData.accumulationNo" placeholder="请输入" />
      </FormItem>
      <FormItem label="银行开户城市">
        <Select v-model="formData.bankProvince" placeholder="省" @on-change="provinceChange('bank', $event)" filterable style="width: calc(50% - 5px)">
          <Option v-for="(item, i) in regionsArr" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
        <Select v-model="formData.bankCity" placeholder="市" filterable style="width: calc(50% - 5px); margin-left: 10px">
          <Option v-for="(item, i) in cityList" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="所在省市">
        <Select v-model="formData.province" placeholder="省" @on-change="provinceChange('user', $event)" filterable style="width: calc(50% - 5px)">
          <Option v-for="(item, i) in regionsArr" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
        <Select v-model="formData.city" placeholder="市" filterable style="width: calc(50% - 5px); margin-left: 10px">
          <Option v-for="(item, i) in cityList2" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem
        prop="address"
        label="具体地址"
        class="two"
        :rules="
          oldAddress || addressEye
            ? { required: false, message: '请输入正确的地址' }
            : { required: false, validator: validateMessage, message: '请输入正确的地址', trigger: 'change' }
        "
      >
        <div class="tips">
          <Input
            v-if="formData.eyeShow4 || !addressEye"
            v-model="formData.address"
            @on-change="addressChange"
            type="textarea"
            placeholder="最多不超过30个字"
            maxlength="30"
            :autosize="{ minRows: 1 }"
            show-word-limit
          />
          <Input
            v-else
            v-model="formData.address1"
            @on-change="addressChange"
            type="textarea"
            placeholder="最多不超过30个字"
            maxlength="30"
            :autosize="{ minRows: 1 }"
            show-word-limit
          />
          <span v-if="addressEye && formData.address1">
            <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow4" @click="openEye('address', 'eyeShow4')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye('address', 'eyeShow4')"></i>
          </span>
        </div>
      </FormItem>
      <!-- <FormItem label="具体地址" class="two">
        <Input v-model="formData.address" type="textarea" placeholder="最多不超过30个字" maxlength="30" :autosize="{ minRows: 1 }" show-word-limit />
      </FormItem> -->
      <FormItem label="身高(cm)" prop="height" :rules="$units.formRule.IntSort()">
        <Input v-model="formData.height" placeholder="请输入" />
      </FormItem>
      <FormItem label="体重(kg)" prop="weight" :rules="$units.formRule.IntSort()">
        <Input v-model="formData.weight" placeholder="请输入" />
      </FormItem>
      <FormItem label="健康状况" prop="health">
        <lzDicSelect v-model="formData.health" dicType="HEAITH_COND"></lzDicSelect>
      </FormItem>
      <FormItem label="犯罪记录" prop="criminalRecord">
        <lzDicSelect v-model="formData.criminalRecord" dicType="HAVE_NOT"></lzDicSelect>
      </FormItem>
      <FormItem label="监管处罚记录" prop="penaltyRecord">
        <lzDicSelect v-model="formData.penaltyRecord" dicType="HAVE_NOT"></lzDicSelect>
      </FormItem>
      <FormItem label="监管报备" prop="supervise" v-if="$units.superviseShowVal()">
        <RadioGroup v-model="formData.supervise">
          <Radio label="0">否</Radio>
          <Radio label="1">是</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="继承人" v-show="formData.workingState == 0">
        <lzSelect placeholder="请输入姓名或工号搜索" v-model="formData.heir" :remote-method="getUserList" :transfer="true" :disabled="!!formData.id">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :value="item.id" :key="i" v-if="item.id != formData.id && item.workingState == '1'">{{ item.name }}</Option>
          </template>
        </lzSelect>
      </FormItem>
      <div v-for="(item, i) in formData.userContactsList" :key="'userContactsList' + i">
        <FormItem :label="`紧急联系人` + (i + 1)">
          <Input v-model="item.name" placeholder="请输入" />
        </FormItem>
        <FormItem label="紧急联系电话">
          <div class="tips">
            <Input v-if="item.eyeShow || !formData.id || item.mobileEye" v-model="item.mobile" @on-change="mobileChange1($event, i)" placeholder="请输入" />
            <Input v-else v-model="item.mobile1" placeholder="请输入" @on-change="mobileChange1($event, i)" />
            <span v-if="!item.mobileEye && item.mobile">
              <i class="iconfont iconxianshi eye-icon" v-if="item.eyeShow && item.id" @click="openEye('mobile', 'eyeShow', i)"></i>
              <i class="iconfont iconyincang eye-icon" v-else-if="!item.eyeShow && item.id" @click="openEye('mobile', 'eyeShow', i)"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="与本人关系">
          <Select v-model="item.reason">
            <Option value="1">父母</Option>
            <Option value="2">配偶</Option>
            <Option value="3">子女</Option>
            <Option value="4">亲戚</Option>
            <Option value="5">朋友</Option>
            <Option value="6">其他</Option>
          </Select>
        </FormItem>
      </div>
      <FormItem label="保证金" v-if="$units.isCSJY()" key="margin">
        <Input v-model="formData.margin" placeholder="请输入" />
      </FormItem>
      <!-- 销售分级/等级（选择——枚举：一级、二级、三级、四级） -->
      <FormItem label="销售分级/等级" :label-width="100" key="agentLevel">
        <lzDicSelect v-model="formData.agentLevel" dicType="AGENT_LEVEL" :transfer="true" clearable />
      </FormItem>
      <template v-if="$units.isOkBao()">
        <!-- 分级/等级考试通过时间（时间插件） -->
        <FormItem label="分级/等级考试通过时间" :label-width="150" key="agentLevelTime">
          <DatePicker type="date" v-model="formData.agentLevelTime" format="yyyy-MM-dd" placeholder="请选择" key="date" />
        </FormItem>
        <!-- 资格证类型（选择——枚举：A、空） -->
        <FormItem label="资格证类型" key="certificateType">
          <lzDicSelect v-model="formData.certificateType" dicType="CERTIFICATE_TYPE" :transfer="true" clearable />
        </FormItem>
        <!-- 万能/分红销售证（单选选择是、否） -->
        <FormItem label="分红万能险销售证" :label-width="125" key="hasWannengCertificate">
          <Select v-model="formData.hasWannengCertificate">
            <Option value="1">是</Option>
            <Option value="0">否</Option>
          </Select>
        </FormItem>
        <!-- 万能/分红证书号（填写） -->
        <FormItem label="分红万能险证书编号" :label-width="135" key="wannengCertificateNo">
          <Input v-model="formData.wannengCertificateNo" placeholder="请输入" />
        </FormItem>
        <!-- 万能/分红证证书有效起期（时间插件） -->
        <FormItem label="分红万能险证书有效起期" :label-width="160" key="wannengCertificateStartDate">
          <DatePicker type="date" v-model="formData.wannengCertificateStartDate" format="yyyy-MM-dd" placeholder="请选择" key="date" />
        </FormItem>
      </template>
      <FormItem label="备注" class="full">
        <Input v-model="formData.remarkExplain" type="textarea" placeholder="最多不超过100个字" maxlength="100" :autosize="{ minRows: 3 }" show-word-limit />
      </FormItem>
    </Form>

    <div class="seize"></div>
    <div v-if="formData.id" class="ivu-modal-footer">
      <Button type="text" v-if="$units.pointAction('org_2_13')" @click="queryRelation">关系查询</Button>
      <Button @click="rankUpdate(3)" v-if="$units.pointAction('org_2_16') && formData.workingState != 0" type="text">迁移</Button>
      <Button @click="resetPassword" type="error" ghost v-if="$units.pointAction('org_2_5') && formData.workingState != 0">重置密码</Button>
      <Button @click="rankUpdate(1)" style="margin-left: 100px" type="text" v-if="$units.pointAction('org_2_14') && formData.workingState != 0">晋升</Button>
      <Button @click="rankUpdate(4)" type="text" v-if="$units.pointAction('org_2_14') && formData.workingState != 0">降级</Button>
      <Button @click="suspension" type="text" v-if="$units.pointAction('org_2_15') && (formData.isSus == 1 || formData.workingState == 0)">复职</Button>
      <Button @click="rankUpdate(5)" type="error" ghost v-else-if="$units.pointAction('org_2_15') && formData.isSus != 1 && formData.workingState != 0"
        >停职</Button
      >
      <Button
        @click="cancelCertificateNumber"
        type="error"
        ghost
        v-if="$units.pointAction('org_2_7') && formData.qualificationFlag == 1 && formData.workingState != 0"
        >注销执业证</Button
      >
      <Button @click="updateCertificateNumber" type="text" ghost v-if="$units.pointAction('org_2_7') && formData.qualificationFlag == 0">执业证上号</Button>
      <Button @click="rankUpdate(6)" type="error" ghost v-if="$units.pointAction('org_2_15') && formData.workingState != 0">离职</Button>
    </div>

    <!-- 新增职级 -->
    <edit-promotion ref="editPromotion" @reload="getRankList"></edit-promotion>

    <!-- 重置密码 -->
    <password-form ref="passwordForm"></password-form>
    <!-- 变更职级 -->
    <rank-update-form ref="rankUpdateForm" @success="setData()" @queryRelation="queryRelation"></rank-update-form>
    <!-- 再次入职 -->
    <re-entry-form ref="reEntryForm" @success="setData()"></re-entry-form>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
    <!-- 关系查询 -->
    <relationModal ref="relationModal"></relationModal>
    <!-- ok保发起离职 -->
    <contractModal ref="contractModal" @success="setData()"></contractModal>

    <updateCertificateNumber ref="updateCertificateNumber" @success="setData()"></updateCertificateNumber>
  </div>
</template>
<script>
import filter from '@/api/filter';
import { uploadFile } from '@/api/httpList';
import { common } from '@/api/mixins';
import relationModal from '../../manage/components/relationModal';
import selectTree from '@/components/system/selectTree3';
import lzDicSelect from '@/components/commons/lzDicSelect';
import lzSelect from '@/components/commons/lzSelect';
import confirmModal from '@/components/commons/confirmModal';
import reEntryForm from '../../manage/components/reEntryForm';
import passwordForm from '../../manage/components/passwordForm';
import contractModal from '../../manage/components/contractModal';
import rankUpdateForm from '../../manage/components/rankUpdateForm';
import editPromotion from '@/pages/personnelMag/promotionManage/components/editModal';
import updateCertificateNumber from '../../manage/components/updateCertificateNumber'; //上号
import upload from '@/components/commons/upload';
export default {
  mixins: [common],
  components: {
    editPromotion,
    selectTree,
    lzDicSelect,
    lzSelect,
    passwordForm,
    contractModal,
    rankUpdateForm,
    reEntryForm,
    confirmModal,
    relationModal,
    updateCertificateNumber,
    upload
  },
  data() {
    return {
      loading: false,
      mobileEye: true,
      idEye: true,
      emailEye: true,
      cardNoEye: true,
      addressEye: true,
      oldMobile: '',
      oldIdNo: '',
      oldEmail: '',
      oldCardNo: '',
      oldAddress: '',
      rankList: [], //职级
      bankList: [], //银行
      nationList: [], //民族
      regionsArr: [], //区域数据
      cityList: [], //市级数据 银行
      cityList2: [], //市级数据
      groupList: [], //团队
      idTypeList: [], //证件类型
      salesSupportList: [], //个险销售支持
      groupSalesSupportList: [], //团险销售支持
      channelList: [], //渠道来源
      formData: {
        isLongEffective: '0',
        userContactsList: [{}, {}],
        isSus: '0',
        workingState: '1',
        isGroupLeader: '0',
        idType: '01',
        supervise: '1',
        groupLeaderId: '',
        groupId: '',
        isSaleSupport: '0',
        saleSupportType: '',
        weixinQrCode: ''
      },
      userId: '',
      registerId: '', //立即入职id
      dic: {},
      userInfo: {}
    };
  },
  created() {
    this.userId = this.$route.query.userId;
    this.registerId = this.$route.query.registerId;
    this.dic = JSON.parse(localStorage.dic);
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  methods: {
    validateMessage(rule, value, callback) {
      if (value.indexOf('*') != -1) {
        callback(new Error('请输入正确的格式'));
      }
      callback();
    },
    strLength() {
      return {
        required: true,
        trigger: 'change',
        validator(rule, value, callback) {
          if (!value) {
            callback(new Error('请输入证件号'));
          } else if (value.length < 6) {
            callback(new Error('证件号至少6位'));
          } else {
            callback();
          }
        }
      };
    },
    updateCertificateNumber() {
      this.$refs.updateCertificateNumber.open(this.formData);
    },
    // 解密
    openEye(key, showKey, val) {
      if (this.formData[showKey]) {
        this.formData[key] = this.formData[key + '1'];
      }
      let operationFunction;
      if (this.registerId) {
        operationFunction = 8;
      } else {
        operationFunction = 1;
      }
      if (val != undefined && String(val)) {
        if (!this.formData.userContactsList[val][showKey]) {
          this.descrypt(
            {
              query: this.formData.id,
              operationFunction: operationFunction,
              operationType: 6,
              otherInfo: {
                userContactsId: this.formData.userContactsList[val].id
              }
            },
            this.formData.userContactsList[val],
            key
          ).then(() => {
            this.$set(this.formData.userContactsList[val], showKey, true);
          });
        } else {
          this.$set(this.formData.userContactsList[val], showKey, false);
        }
      } else {
        if (!this.formData[showKey]) {
          const map = {
            idNo: 1,
            mobile: 2,
            cardNo: 3,
            email: 4,
            address: 5
          };
          this.descrypt(
            {
              query: this.formData.id,
              operationFunction: operationFunction,
              operationType: map[key]
            },
            this.formData,
            key
          ).then(() => {
            this.$set(this.formData, showKey, true);
          });
        } else {
          this.$set(this.formData, showKey, false);
        }
      }
    },
    //关系查询
    queryRelation() {
      this.$refs.relationModal.open({ userId: this.userId });
    },
    changeGroup(val) {
      let group = this.groupList.find(i => i.groupId == val);
      this.$refs.form.validateField('groupId');
      if (this.$units.isOkBao() || this.$units.isOkTX()) return;
      if (group && group.leaderId) {
        this.formData.groupLeaderId = group.leaderId;
      } else {
        this.formData.groupLeaderId = '';
      }
    },
    // 注销执业证
    cancelCertificateNumber() {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否禁止此业务员出单？'
        })
        .then(async () => {
          this.$http({
            url: '/buz/userBase/cancelCertificateNumber',
            type: 'get',
            data: {
              id: this.formData.id
            },
            apiPermissionCode: 'org_2_7'
          }).then(res => {
            this.$notice.success('操作成功');
            this.setData();
          });
        });
    },
    //复职
    suspension() {
      if (this.formData.workingState == 0) {
        //离职状态 二次入司 关闭详情页，打开新建业务员的弹窗
        let route = this.$route;
        this.$router.push({
          path: route.path,
          query: {
            ...route.query,
            isAdd: 1 //二次入司
          }
        });
        window.setTimeout(() => {
          window.parent.postMessage(
            {
              removePageTag: route.fullPath,
              appMessage: true
            },
            '*'
          );
        }, 100);
      } else {
        //停职状态 复职
        this.rankUpdate(7);
      }
    },
    // 职级变更
    rankUpdate(type) {
      if (type == 6 && (this.$units.isOkBao() || this.$units.isOkTX())) {
        //ok保离职
        this.$refs.contractModal.open({ ...this.formData, recommendId: this.formData.recommendUserId, recommendName: this.formData.recommendUserName });
      } else {
        this.$refs.rankUpdateForm.open({ ...this.formData, type });
      }
    },
    // 重置密码
    resetPassword() {
      this.$refs.passwordForm.open({ id: this.userId });
    },
    //自动生成工号
    createStaffNo() {
      this.$http({
        type: 'GET',
        url: '/buz/userBase/auto/staffNo',
        data: {
          orgId: this.formData.organizationId,
          groupId: this.formData.groupId
        }
      }).then(res => {
        this.$set(this.formData, 'staffNo', res.data);
      });
    },
    save() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate().then(isok => {
          if (!isok) {
            reject({ page: 'base', showMsg: true });
            return;
          }
          const formData = JSON.parse(JSON.stringify(this.formData));

          if (this.registerId) {
            //在线入职
            formData.registerId = this.registerId;
          } else if (!this.userId) {
            //非在线入职 新增时
            // formData.groupId = this.$route.query.groupId || this.formData.groupId;
            // formData.organizationId = this.$route.query.organizationId;
          }
          formData.isGroupLeader = formData.isGroupLeader == 1;
          formData.entryTime = this.$units.formatDate(formData.entryTime);
          if (formData.isLongEffective == 1) {
            formData.effectiveTimeStart = this.$units.formatDate(formData.date2);
            formData.effectiveTimeEnd = '';
          } else if (formData.date && formData.date[0]) {
            formData.effectiveTimeStart = this.$units.formatDate(formData.date[0]);
            formData.effectiveTimeEnd = this.$units.formatDate(formData.date[1]);
          }
          if (this.oldMobile == formData.mobile) {
            delete formData.mobile;
          }
          if (this.oldIdNo == formData.idNo) {
            delete formData.idNo;
          }

          if (this.$route.query.agentId) {
            formData.agentId = this.$route.query.agentId;
          }
          // 在职删除离职时间
          if (formData.workingState == '1') {
            delete formData.resignTime;
          }
          this.$http({
            type: 'POST',
            url: formData.id ? '/buz/userBase/edit' : '/buz/userBase/add',
            data: formData,
            apiPermissionCode: 'org_2_2'
          })
            .then(res => {
              resolve();
              this.mobileEye = true;
              this.idEye = true;
              this.oldMobile = this.formData.mobile;
              this.oldIdNo = this.formData.idNo;
              this.oldEmail = this.formData.email;
              this.oldCardNo = this.formData.cardNo;
              this.oldAddress = this.formData.address;
              if (!this.userId) {
                this.$emit('save', res.data);
              } else {
                this.$emit('save', formData);
              }
            })
            .catch(res => {
              reject({ page: 'base' });
            });
        });
      });
    },
    async setData() {
      this.oldMobile = '';
      this.oldIdNo = '';
      this.oldEmail = '';
      this.oldCardNo = '';
      this.oldAddress = '';
      await this.getRegion();
      await this.getUserData();
      this.getCardType();
      this.getRankList();
      this.getBankList();
      this.getNationList();
      if (this.$units.isOkBao() || this.$units.isRYBB()) {
        this.getOkBaoSalesSupport();
        this.getChannelList();
      }
      this.$emit('init', this.formData);
    },
    // 业务员数据,清空数据
    getUserData() {
      if (this.registerId) {
        //在线入职
        return this.getRegisterDetail();
      }
      if (!this.userId) {
        //新增不执行
        this.$refs.form && this.$refs.form.resetFields();
        this.formData = {
          date2: null,
          isLongEffective: '0',
          userContactsList: [{}, {}],
          isSus: '0',
          workingState: '1',
          isGroupLeader: '0',
          idType: '01',
          groupId: this.$route.query.groupId,
          organizationId: this.$route.query.organizationId,
          supervise: '1',
          isSaleSupport: '0',
          saleSupportType: ''
        };
        this.$nextTick(() => {
          this.$refs.selectTree && this.$refs.selectTree.openChange();
        });
        return;
      }
      this.loading = true;
      return this.$http({
        url: '/buz/userBase/read/detail',
        type: 'get',
        data: {
          id: this.userId
        }
      })
        .then(res => {
          this.loading = false;
          const data = res.data;
          this.detailDataFormat(data);
          this.formData = data;
          if (this.$route.query.isAdd == 1) {
            delete this.formData.id;
            delete this.formData.staffNo;
            delete this.formData.entryTime;
            delete this.formData.certificateNumber;
            this.formData.userContactsList.forEach(item => {
              if (item.id) {
                delete item.id;
              }
            });
            this.formData.workingState = '1';
            this.formData.isSus = '0';
            this.$nextTick(() => {
              this.$refs.selectTree && this.$refs.selectTree.openChange();
            });
          }
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    // 详情接口数据处理
    detailDataFormat(data) {
      if (!data.userContactsList || data.userContactsList.length == 0) {
        data.userContactsList = [{}, {}];
      }
      data.isLongEffective = data.isLongEffective == 1 ? '1' : '0';
      data.isGroupLeader = data.isGroupLeader ? '1' : '0';
      data.userId = data.recommendUserId; //推荐人id
      data.entryTime = data.entryTime ? this.$units.formatDate(data.entryTime) : data.entryTime;
      if (data.effectiveTimeStart && data.effectiveTimeEnd) {
        data.date = [new Date(data.effectiveTimeStart), new Date(data.effectiveTimeEnd)];
      } else {
        data.date = [];
      }
      if (data.effectiveTimeStart) {
        data.date2 = new Date(data.effectiveTimeStart);
      } else {
        data.date2 = null;
      }
      this.oldMobile = data.mobile;
      this.oldIdNo = data.idNo;
      this.oldEmail = data.email;
      this.oldCardNo = data.cardNo;
      this.oldAddress = data.address;
      if (data.bankProvince) {
        const region = this.regionsArr.find(item => {
          return item.name == data.bankProvince;
        });
        this.cityList = region?.children;
      }
      if (data.province) {
        const region = this.regionsArr.find(item => {
          return item.name == data.province;
        });
        this.cityList2 = region?.children;
      }
      // 销支回显
      if (data.isSaleSupport == '1') {
        data.saleSupportId = data.id;
      }
    },
    // 获取在线入职详情
    getRegisterDetail() {
      this.loading = true;
      return this.$http({
        url: '/buz/entryUserAuth/read/detail',
        type: 'get',
        data: {
          id: this.registerId
        }
      }).then(res => {
        this.loading = false;
        const data = res.data;
        data.mobile = data.mobile1;
        data.workingState = '1';
        data.isSus = '0';
        data.idType = '01';
        this.detailDataFormat(data);
        data.userId = data.recommenderId;
        this.formData = data;
        this.$nextTick(() => {
          this.$refs.selectTree && this.$refs.selectTree.openChange();
        });
      });
    },
    // 获取团队列表
    getGroupList(val) {
      this.$refs.recommendSelect.reload();
      this.$http({
        url: '/buz/organizationGroup/getSubGroup',
        type: 'get',
        data: {
          organizationId: this.formData.organizationId
        }
      }).then(res => {
        this.groupList = res.data;
        if (this.groupList.length == 1) {
          this.formData.groupId = this.groupList[0].groupId;
        } else {
          if (this.$route.query.groupId && res.data.find(i => i.groupId == this.$route.query.groupId)) {
            this.formData.groupId = this.$route.query.groupId;
            if (!(this.$units.isOkBao() || this.$units.isOkTX())) {
              this.formData.groupLeaderId = res.data.find(i => i.groupId == this.$route.query.groupId).leaderId;
            }
          } else {
            this.formData.groupId = '';
          }
        }
        if (this.formData.groupId && !(this.$units.isOkBao() || this.$units.isOkTX())) {
          let group = res.data.find(i => i.groupId == this.formData.groupId);
          if (group && group.leaderId) {
            this.formData.groupLeaderId = group.leaderId;
          }
        }
      });
    },
    // 职级列表
    getRankList() {
      this.$http({
        url: '/buz/baseRank/read/all',
        type: 'post',
        data: {}
      }).then(res => {
        this.rankList = res.data;
      });
    },
    // 获取银行列表
    getBankList() {
      this.bankList = this.dic['BANK_TYPE'];
    },
    getCardType() {
      this.$http({
        url: '/system/dic/read/dicList',
        type: 'POST',
        data: {
          code: 'USER_CARD_TYPE'
        }
      }).then(res => {
        this.idTypeList = res.data;
      });
    },
    // 获取民族列表
    getNationList() {
      this.nationList = JSON.parse(Object.getOwnPropertyNames(this.dic['NATION'])[0]);
    },
    getChannelList() {
      this.$http({
        url: '/buz/entryUserAuth/getSourceChannel',
        type: 'GET',
        data: {}
      }).then(res => {
        if (res.data) {
          this.channelList = res.data.split(',');
        }
      });
    },
    // 获取个险、团险销售支持
    getOkBaoSalesSupport() {
      this.$http({
        url: '/buz/userBase/okbao/getSalesSupport',
        type: 'GET',
        data: {
          type: 1
        }
      }).then(res => {
        if (res.data) {
          this.salesSupportList = res.data;
        } else {
          this.salesSupportList = [
            {
              name: this.formData.name,
              id: this.formData.id
            }
          ];
        }
      });
      this.$http({
        url: '/buz/userBase/okbao/getSalesSupport',
        type: 'GET',
        data: {
          type: 2
        }
      }).then(res => {
        if (res.data) {
          this.groupSalesSupportList = res.data;
        } else {
          this.groupSalesSupportList = [
            {
              name: this.formData.name,
              id: this.formData.id
            }
          ];
        }
      });
    },
    // 获取当前机构业务员
    getUserList(keyword) {
      if (!keyword) {
        return;
      }
      const params = {
        orgaList: [this.$route.query.organizationId || this.formData.organizationId]
      };
      if (/^\d{19}$/.test(keyword)) {
        // 初始化时keyword是id
        params.userId = keyword;
      } else {
        params.userName = keyword;
      }
      return this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'post',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    // 查询推荐人 如果允许跨机构则机构id无所谓。不允许就会查机构的
    getIntroUserList(keyword) {
      if (!keyword) {
        return;
      }
      const params = {
        orgId: this.formData.organizationId || this.$route.query.organizationId
      };
      if (/^\d{19}$/.test(keyword)) {
        // 初始化时keyword是id
        params.userId = keyword;
      } else {
        params.userName = keyword;
      }
      return this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'get',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    //经理人职级业务员
    getOkBaoOrgUserList(keyword) {
      if (!keyword) {
        return;
      }
      let params = {};
      if (/^\d{19}$/.test(keyword)) {
        // 初始化时keyword是id
        params.userId = keyword;
      } else {
        params.userName = keyword;
        if (this.$units.isOkBao() || this.$units.isOkTX()) {
          //ok保筛选在职人员
          params.workingState = '1';
          params.isSus = '0';
          params.orgId = '';
          params.filter = '1';
        }
      }
      return this.$http({
        url: '/buz/userBase/queryUserByEntryConfig',
        type: 'get',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    // 机构内部业务员
    getOrgUserList(keyword) {
      if (!keyword) {
        return;
      }
      let params = {
        orgId: this.$route.query.organizationId || this.formData.organizationId
      };
      if (/^\d{19}$/.test(keyword)) {
        // 初始化时keyword是id
        params.userId = keyword;
      } else {
        params.userName = keyword;
      }
      if (this.$units.isOkBao() || this.$units.isOkTX()) {
        //ok保筛选在职人员
        params.workingState = '1';
        params.isSus = '0';
        params.orgId = '';
      }
      return this.$http({
        url: '/buz/userBase/queryUserByEntryConfig',
        type: 'get',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    // 获取省市区域数据
    async getRegion() {
      this.regionsArr = await this.$store.dispatch('getRegion');
    },
    // 选择省
    provinceChange(type, name) {
      const data = this.regionsArr.find(item => {
        return item.name == name;
      });
      if (type == 'bank') {
        this.$set(this.formData, 'bankCity', '');
        this.cityList = data.children;
      } else {
        this.$set(this.formData, 'city', '');
        this.cityList2 = data.children;
      }
    },
    // 身份证有效期类型切换
    isLongEffectiveChange() {
      if (this.formData.isLongEffective == 1) {
        this.$set(this.formData, 'date', []);
      }
    },
    addressChange(e) {
      this.$set(this.formData, 'address', e.target.value);
      this.oldAddress = '';
      this.addressEye = false;
    },
    emailChange(e) {
      this.$set(this.formData, 'email', e.target.value);
      this.oldEmail = '';
      this.emailEye = false;
    },
    // 手机号修改
    mobileChange(e) {
      this.$set(this.formData, 'mobile', e.target.value);
      this.oldMobile = '';
      this.mobileEye = false;
    },
    // 紧急联系人修改
    mobileChange1(e, val) {
      this.$set(this.formData.userContactsList, 'mobile', e.target.value);
      this.formData.userContactsList[val].mobileEye = true;
    },
    // 身份证号修改
    idCardChange(e, val) {
      this.oldIdNo = '';
      this.idEye = false;
      this.$set(this.formData, 'idNo', e.target.value);
      if (!val) {
        const idCard = e.target.value;
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(idCard)) {
          const date = idCard.substr(6, 4) + '-' + idCard.substr(10, 2) + '-' + idCard.substr(12, 2);
          this.$set(this.formData, 'birthday', date);
        }
        const sex = idCard.substr(16, 1) % 2 == 1 ? '1' : '2';
        this.$set(this.formData, 'sex', sex);
      }
    },
    // 出生日期选择
    changeBirthday(value) {
      this.$set(this.formData, 'birthday', value);
    },
    // 银行卡
    cardNoChange(e) {
      this.oldCardNo = '';
      this.cardNoEye = false;
      const cardNo = e.target.value;
      this.$set(this.formData, 'cardNo', e.target.value);
      if (cardNo && cardNo.length > 15 && cardNo.length < 20) {
        this.$http({
          url: '/buz/userCertificate/queryBankByCardNo',
          type: 'GET',
          data: {
            cardNo
          }
        }).then(res => {
          if (res.data) {
            this.getBankList();
            for (let i in this.bankList) {
              if (this.bankList[i] == res.data) {
                this.$set(this.formData, 'bank', i);
              }
            }
          }
        });
      }
    },
    removeCover() {
      this.$set(this.formData, 'weixinQrCode', '');
    },
    // 上传
    toloadFile(file) {
      let formData = new FormData();
      formData.append('file', file);
      uploadFile(formData).then(res => {
        this.$set(this.formData, 'weixinQrCode', res.data[0].path);
        this.$refs.form.validateField('weixinQrCode'); // 清除表单校验：文件
      });
    },
    // 销支回显
    onChangeIsSaleSupport(value) {
      if (value == 1) {
        let ids = this.salesSupportList.map(item => item.id);
        if (!ids.includes(this.formData.id)) {
          this.salesSupportList.push({ id: this.formData.id, name: this.formData.name });
        }
        this.$set(this.formData, 'saleSupportId', this.formData.id);
        if (!this.formData.saleSupportType) {
          // 如果没有销支类型，则默认选择个险
          this.$set(this.formData, 'saleSupportType', 1);
        }
      } else {
        this.formData.saleSupportType = '';
        this.formData.saleSupportId = '';
        this.formData.groupSaleSupportId = '';
        this.salesSupportList = this.salesSupportList.filter(item => item.id != this.formData.id);
      }
    },
    // 销支类型
    onChangeSaleSupportType(value) {
      if (value == 1) {
        this.formData.groupSaleSupportId = '';
        let ids = this.salesSupportList.map(item => item.id);
        if (!ids.includes(this.formData.id)) {
          this.salesSupportList.push({ id: this.formData.id, name: this.formData.name });
        }
        this.$set(this.formData, 'saleSupportId', this.formData.id);
      } else if (value == 2) {
        this.formData.saleSupportId = '';
        let ids = this.groupSalesSupportList.map(item => item.id);
        if (!ids.includes(this.formData.id)) {
          this.groupSalesSupportList.push({ id: this.formData.id, name: this.formData.name });
        }
        this.$set(this.formData, 'groupSaleSupportId', this.formData.id);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.eye-icon {
  cursor: pointer;
  margin-left: 5px;
}

/deep/.ivu-btn-error {
  background-color: #fff;
}

.seize {
  height: 70px;
}

.ivu-modal-footer {
  position: fixed;
  width: 99.5%;
  bottom: 0px;
  z-index: 99;
  left: 0;
  text-align: right;
  padding-top: 24px;
  padding-bottom: 24px;
  background-color: #fff;
  box-shadow: 0px -2px 4px 1px rgba(0, 0, 0, 0.05);
}

.tips {
  display: flex;
}

/deep/.flex {
  .ivu-form-item-content {
    display: flex;

    .ivu-input-wrapper {
      flex: 1;
    }

    .ivu-btn {
      margin-left: 20px;
    }
  }
}

.salesman-form-base {
  padding-top: 15px;
}

.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);

  &.red {
    background: #e3461f;
  }
}

/deep/ .ivu-select-item {
  font-size: 12px !important;
}

.page-form {
  margin-right: -50px;
}

.page-form .ivu-form-item {
  padding-right: 50px;
}

.text-btn {
  color: #236dff;
  font-size: 12px;
  margin-left: 10px;
  cursor: pointer;
}

@media screen and (min-width: 1400px) {
  .page-form {
    width: 1400px;
  }
}
</style>
